import { RequestState } from "../../../constants/request-state";
import { SaveNoteReplayModel } from "../../../types/note/Note";
import { transactionNotesService } from "../../../services/transaction-notes.service";
import { useReducer } from "react";
import { notesRequestActions, NotesRequestReducer } from "../state/notes-request-state";

export function useTransactionNoteReplySave() {
    const [requestState, dispatch] = useReducer(NotesRequestReducer, {})

    const replySaveCallback = async (reply: SaveNoteReplayModel) => {
        dispatch(notesRequestActions.stateChanged(reply.id ?? 0, RequestState.request));
        
        try {
            const noteResult = await transactionNotesService.saveNoteReply(reply);
            dispatch(notesRequestActions.stateChanged(reply.id ?? 0, RequestState.success));
            return noteResult;
        } catch (e) {
            dispatch(notesRequestActions.stateChanged(reply.id ?? 0, RequestState.failure));
        }

        return null;
    }

    return { requestState, replySaveCallback };
}